<template>
  <path d="M 70 30 l 35 10 l 0 20 l -35 10 Z " stroke="none" />
</template>
